import React, {useState, useRef, useEffect} from 'react';
import {useIdleTimer} from 'react-idle-timer';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import {LabelText} from '../../components/Language/LabelText';
import config from '../../common/const/config'
import {validateToken} from '../../common/const/token-helper';
import './index.css';

export const IdleTimerContainer = (props)=> {
    const [isModelOpen, setIsModelOpen]=useState(false);
    const [sessionTimeLeft, setSessionTimeLeft]=useState(null);
    const sessionTimeoutRef=useRef(null);

    const calculateTimeLeft = () => {
        let timeLeftData = {};
        const difference = sessionTimeLeft ? sessionTimeLeft : props.sessionTimeoutLimit/1000;
        const minutes=Math.floor((difference / 60) % 60);
        const seconds=Math.floor((difference) % 60)
        if (difference >= 0) {
            timeLeftData = {
            min: minutes > 0 ? minutes : 0 ,
            sec: seconds,
          };
        } 
        return timeLeftData;
    };

    const setTitle = (title) => {
        const timerValue=calculateTimeLeft();
        const inActiveTitle = timerValue && (timerValue.min>0 || timerValue.sec >0) ? "("+timerValue.min+ ":"+ (timerValue.sec)+") "+ title : title
        document.title=inActiveTitle;
    }
    
    const handleOnIdle = () => {
        setIsModelOpen(true);
        setSessionTimeLeft(props.sessionTimeoutLimit/1000);
        sessionTimeoutRef.current = setTimeout(handleLogout, (props.sessionTimeoutLimit));
    }

    const {
        reset,
      } = useIdleTimer({
        timeout: props.idleTimeoutLimit,
        onIdle: handleOnIdle,
        events: [
        'keydown', 
        'wheel', 
        'mousewheel', 
        'mousedown', 
        'touchstart', 
        'touchmove', 
        'MSPointerDown'
        ]
    })

    useEffect(() => {
        let intervalId = setInterval(()=>validateToken(), 1000 * 60 * config.refreshTokenTimeInterval);
        return () => clearInterval(intervalId); 
    }, []);

    const handleStayActive = () => {
        document.title = config.appTitle;
        setIsModelOpen(false);
        setSessionTimeLeft(null);
        clearTimeout(sessionTimeoutRef.current);
        reset();
    }

    const handleLogout = () => {
        document.title = config.appTitle;
        setIsModelOpen(false);
        setSessionTimeLeft(null);
        clearTimeout(sessionTimeoutRef.current);
        props.logout(true);
    }

    useEffect(() => {
        if(isModelOpen) {
                if(!document.hidden) {
                    let timer = setTimeout(() => {
                                    if(document.title !== config.appTitle) document.title = config.appTitle;
                                    setSessionTimeLeft(st=>sessionTimeLeft-1);
                                }, 1000);
                    return () => clearTimeout(timer);
                }
                else {
                    let timer = setTimeout(() => {
                                    setTitle(config.appTitle);
                                    setSessionTimeLeft(st=>sessionTimeLeft-1);
                                }, 500);
                    return () => clearTimeout(timer);
                }
               
        }
    },[isModelOpen, sessionTimeLeft]);

    const Timer = ()  => {
        const timerComponents = [];
        const timerValue=calculateTimeLeft();
        Object.keys(timerValue).forEach((interval) => {
            if (timerValue[interval]<0) {
            return;
            }

            timerComponents.push(
            <span key={interval} style={{color: "rgb(8, 11, 189)", fontWeight: "bold"}}>
                {timerValue[interval] <10 ? "0" + timerValue[interval] : timerValue[interval]} <LabelText tid={interval} />{" "}
            </span>
            );
        });

        return (timerComponents.length ? timerComponents : <span></span>)
    }

    return (
        <div className="Modal-container">
            <Modal show={isModelOpen} onHide={handleStayActive}>
                <Modal.Header closeButton className="Modal-header">
                <Modal.Title className="Modal-header-title"><LabelText tid="session_timeout" /></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="Modal-body-message-container">
                        <span><b><LabelText tid="session_expire_msg" />:</b></span><br/>
                        <Timer /><br/>
                        <span><LabelText tid="session_timeout_msg" /></span><br/>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                <Button variant="primary" size="sm" onClick={handleStayActive}>
                    <LabelText tid="continue" />
                </Button>
                <Button variant="secondary" size="sm" onClick={handleLogout}>
                    <LabelText tid="logoff" />
                </Button>
                </Modal.Footer>
            </Modal>

            {/* <IdleTimer
                ref={idleTimerRef}
                timeout={props.idleTimeoutLimit}
                onIdle={handleOnIdle}
            /> */}
        </div>
    );
}

export default IdleTimerContainer;